// CXone hostname for SDK initialization
export const CXONE_HOSTNAME = 'https://cxone.niceincontact.com';
